import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const PaymentIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ height = 12, width = 12, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 8 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M6.35 4C6.25048 3.71762 6.06872 3.47148 5.82814 3.29327C5.58755 3.11505 5.29913 3.01292 5 3H3C2.60218 3 2.22064 3.15804 1.93934 3.43934C1.65804 3.72064 1.5 4.10218 1.5 4.5C1.5 4.89782 1.65804 5.27936 1.93934 5.56066C2.22064 5.84196 2.60218 6 3 6H5C5.39782 6 5.77936 6.15804 6.06066 6.43934C6.34196 6.72064 6.5 7.10218 6.5 7.5C6.5 7.89782 6.34196 8.27936 6.06066 8.56066C5.77936 8.84196 5.39782 9 5 9H3C2.70087 8.98708 2.41245 8.88495 2.17186 8.70673C1.93128 8.52852 1.74952 8.28238 1.65 8M4 1.5V3M4 9V10.5"
          stroke="white"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
